<script lang="ts">
  import { i18n } from "../../i18n.svelte";
  import Sprout from "../Sprout.svelte";

  const M = {
    ja: {
      title: "学びの庭",
      streak: "12日連続",
      plots: [
        { name: "英語", pct: 82, stage: 4 },
        { name: "数学", pct: 54, stage: 3 },
        { name: "プログラミング", pct: 23, stage: 2 },
      ],
      week: "今週の学習（分）",
      days: ["月", "火", "水", "木", "金", "土", "日"],
      tiles: [
        { v: "12", l: "連続日数" },
        { v: "284", l: "今週の分" },
        { v: "47", l: "習得トピック" },
      ],
    },
    en: {
      title: "Your garden",
      streak: "12-day streak",
      plots: [
        { name: "English", pct: 82, stage: 4 },
        { name: "Math", pct: 54, stage: 3 },
        { name: "Programming", pct: 23, stage: 2 },
      ],
      week: "This week (minutes)",
      days: ["M", "T", "W", "T", "F", "S", "S"],
      tiles: [
        { v: "12", l: "day streak" },
        { v: "284", l: "min this week" },
        { v: "47", l: "topics mastered" },
      ],
    },
  } as const;
  const m = $derived(M[i18n.locale]);
  const bars = [40, 70, 55, 90, 60, 30, 80];
</script>

<div class="scr">
  <div class="bar">
    <strong>{m.title}</strong>
    <span class="streak">🔥 {m.streak}</span>
  </div>

  <div class="plots">
    {#each m.plots as p}
      <div class="plot">
        <Sprout size={34} stage={p.stage as 1 | 2 | 3 | 4} soil />
        <span class="pn">{p.name}</span>
        <span class="pp">{p.pct}%</span>
      </div>
    {/each}
  </div>

  <div class="chart">
    <p class="clab">{m.week}</p>
    <div class="bars">
      {#each bars as h, i}
        <div class="col">
          <div class="b" style="height:{h}%"></div>
          <span>{m.days[i]}</span>
        </div>
      {/each}
    </div>
  </div>

  <div class="tiles">
    {#each m.tiles as t}
      <div class="tile">
        <strong>{t.v}</strong>
        <span>{t.l}</span>
      </div>
    {/each}
  </div>
</div>

<style>
  .scr {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    padding: 2.4rem 0.9rem 0.9rem;
    background:
      radial-gradient(120% 40% at 0% 0%, rgba(95, 179, 100, 0.12), transparent 60%),
      var(--paper-card);
    font-size: 12px;
  }
  .bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .bar strong {
    font-size: 14px;
    font-family: var(--font-mincho), serif;
    color: var(--ink);
  }
  .streak {
    font-size: 10.5px;
    font-weight: 700;
    color: var(--terra-deep);
    background: rgba(194, 105, 60, 0.12);
    padding: 0.3em 0.6em;
    border-radius: 999px;
  }

  .plots {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.45rem;
  }
  .plot {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.7rem 0.3rem 0.6rem;
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 12px;
  }
  .pn {
    font-size: 10px;
    color: var(--ink-soft);
  }
  .pp {
    font-family: var(--font-mono);
    font-size: 11px;
    font-weight: 700;
    color: var(--green-deep);
  }

  .chart {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 12px;
    padding: 0.7rem 0.75rem 0.6rem;
  }
  .clab {
    font-size: 10px;
    color: var(--muted);
    margin-bottom: 0.45rem;
  }
  .bars {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 5px;
    height: 56px;
  }
  .col {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    height: 100%;
    justify-content: flex-end;
  }
  .b {
    width: 100%;
    border-radius: 4px 4px 2px 2px;
    background: linear-gradient(var(--sprout), var(--green));
    min-height: 4px;
  }
  .col span {
    font-size: 8.5px;
    color: var(--muted);
  }

  .tiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.45rem;
    margin-top: auto;
  }
  .tile {
    text-align: center;
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 10px;
    padding: 0.5rem 0.2rem;
  }
  .tile strong {
    display: block;
    font-family: var(--font-mono);
    font-size: 16px;
    color: var(--green-deep);
  }
  .tile span {
    font-size: 8.5px;
    color: var(--muted);
  }
</style>
